// Analytics utility functions
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Generate a simple session ID
const generateSessionId = () => {
  return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

// Get current user ID from localStorage
const getUserId = () => {
  try {
    // Try to get user data from localStorage (stored by AuthContext)
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        console.log('User data from localStorage:', user); // Debug log
        return user.id || user.user_id || user.mobile || null;
      } catch {
        return null;
      }
    }
    
    // Fallback: try to decode JWT to get user ID
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('JWT payload:', payload); // Debug log
        return payload.sub || payload.user_id || payload.user?.id || null;
      } catch {
        return null;
      }
    }
    console.log('No user ID found'); // Debug log
    return null;
  } catch (error) {
    console.error('Error getting user ID:', error); // Debug log
    return null;
  }
};

// Track website visit (once per session)
export const trackWebsiteVisit = async () => {
  try {
    // Check if visit is already tracked in this session
    if (typeof sessionStorage !== 'undefined') {
      const visitTracked = sessionStorage.getItem('visitTracked');
      if (visitTracked) {
        return; // Already tracked in this session
      }

      // Get session ID
      let sessionId = sessionStorage.getItem('sessionId');
      if (!sessionId) {
        sessionId = generateSessionId();
        sessionStorage.setItem('sessionId', sessionId);
      }

      // Get user ID if logged in
      const userId = getUserId();

      // Track visit
      const response = await fetch(`${API_BASE}/api/analytics/visit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: sessionId,
          user_id: userId,
          ip_address: null, // Server will handle this
          user_agent: navigator.userAgent,
        }),
      });

      if (response.ok) {
        sessionStorage.setItem('visitTracked', 'true');
      }
    }
  } catch (error) {
    console.error('Error tracking website visit:', error);
    // Don't fail the app if analytics fails
  }
};

// Track product view
export const trackProductView = async (productId) => {
  try {
    // Get user ID if logged in
    const userId = getUserId();

    const response = await fetch(`${API_BASE}/api/analytics/product-view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: productId,
        user_id: userId,
      }),
    });
  } catch (error) {
    console.error('Error tracking product view:', error);
    // Don't fail the app if analytics fails
  }
};

// Track cart event (add to cart)
export const trackCartEvent = async (productId, quantity, eventType = 'add') => {
  try {
    // Get user ID if logged in
    const userId = getUserId();

    const response = await fetch(`${API_BASE}/api/analytics/cart-event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: productId,
        user_id: userId,
        quantity: quantity,
        event_type: eventType, // "add" or "remove"
      }),
    });
  } catch (error) {
    console.error('Error tracking cart event:', error);
    // Don't fail the app if analytics fails
  }
};
